import React from "react";
import { NewTab, PageHeader, PageTab, PageTitle } from "../../../../components";
import OpenInvoices from "./Invoicesandpayments/OpenInvoices";
import DueInvoices from "./Invoicesandpayments/DueInvoices";
import PaidInvoices from "./Invoicesandpayments/PaidInvoices";
import AllInvoices from "./Invoicesandpayments/AllInvoices";
import Payments from "./Invoicesandpayments/Payments";

const Invoicesandpayments = ({ isEditable, editClient, clientId }) => {
  const InvoicesandpaymentsMenus = [
    {
      title: "Open Invoices",
      page: <OpenInvoices clientId={clientId} />,
      type: "main",
    },
    {
      title: "Due Invoices",
      page: <DueInvoices clientId={clientId} />,
      type: "main",
    },
    {
      title: "Paid Invoices",
      page: <PaidInvoices clientId={clientId} />,
      type: "main",
    },
    {
      title: "All Invoices",
      page: <AllInvoices clientId={clientId} />,
      type: "main",
    },
    {
      title: "Payments",
      page: <Payments clientId={clientId} />,
      type: "main",
    },
  ];
  return (
    <div>
      <PageHeader
        Section={
          <div className="flex mb-8 mt-4">
            <PageTitle
              title={"Invoices and payments"}
              icon={"badge"}
              tag="h5"
            />
          </div>
        }
      />
      <NewTab
        tabs={InvoicesandpaymentsMenus}
        color="black"
        variant="text"
        activeVariant="text"
        mode="url"
        tabId="invoices-and-payments"
      />
    </div>
  );
};

export default Invoicesandpayments;
